import { render, staticRenderFns } from "./collectioncensus.vue?vue&type=template&id=0ed2331b&"
import script from "./collectioncensus.vue?vue&type=script&lang=js&"
export * from "./collectioncensus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports